import React from "react";
import { RankingMetaColetivaViewProps } from "../types";
import { NavigationButtons } from "./NavigationButtons";
import { LojaSelector } from "./LojaSelector";
import { Header } from "./Header";
import { DateFilters } from "./DateFilters";
import { NotasCards } from "./NotasCards";
import { ControleTempo } from "./ControleTempo";
import { MetaAtingidaCard } from "./MetaAtingidaCard";

export const RankingMetaColetivaView: React.FC<
  RankingMetaColetivaViewProps
> = ({
  metaColetiva,
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  selectedLojaNome,
  metasCount = 0,
  startDate = "",
  endDate = "",
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
  onStartDateChange,
  onEndDateChange,
  onApplyFilter,
}) => {
  const hasFilterHandlers = Boolean(
    onStartDateChange && onEndDateChange && onApplyFilter
  );

  return (
    <div className="relative min-h-screen overflow-y-auto overflow-x-hidden bg-slate-900 text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
      />

      <LojaSelector
        lojas={lojas}
        selectedLojaId={selectedLojaId}
        showLojaSelector={showLojaSelector}
        onSelectAllLojas={onSelectAllLojas}
        onSelectLoja={onSelectLoja}
      />

      <Header
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
      />

      <DateFilters
        startDate={startDate}
        endDate={endDate}
        metasCount={metasCount}
        hasFilterHandlers={hasFilterHandlers}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onApplyFilter={onApplyFilter}
      />

      <div className="mx-auto max-w-5xl px-4 pb-8">
        <NotasCards metaColetiva={metaColetiva} />

        <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <ControleTempo metaColetiva={metaColetiva} />
          <MetaAtingidaCard metaColetiva={metaColetiva} />
        </div>
      </div>
    </div>
  );
};
